/* Utils */
import { generateEntityActionTypes } from '../utils/generators/actionTypeGenerators';

const ENTITY_NAME = 'SEASONS';

export const FETCH_SEASON_BY_ID = `${ENTITY_NAME}/FETCH/BY_ID`;
export const SEASON_ENTITY_ACTION_TYPES = generateEntityActionTypes(ENTITY_NAME);
